import React from 'react';
import { Outlet } from 'react-router-dom';

const HomeSupplier = () => {
  return <Outlet />;
};

export default HomeSupplier;
